import React from "react";
import { TROPHIES } from "../data/trophies";
import { DS } from "../theme";

export default function TrophyCase({ stats }) {
  const earnedIds = new Set((stats.earnedTrophies || []).map(t => t.id));
  const earned = TROPHIES.filter(t => earnedIds.has(t.id));
  const locked = TROPHIES.filter(t => !earnedIds.has(t.id));

  return (
    <div>
      {/* Progress */}
      <div style={card}>
        <div style={label}>Trophy Progress</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <span style={{ fontSize: 13, color: DS.textMuted }}>{earned.length} of {TROPHIES.length} unlocked</span>
          <span style={{ fontSize: 13, fontWeight: 700, color: DS.accent }}>{Math.round((earned.length / TROPHIES.length) * 100)}%</span>
        </div>
        <div style={{ height: 6, background: DS.elevated, borderRadius: 3, overflow: "hidden" }}>
          <div style={{
            height: "100%", borderRadius: 3, transition: "width 0.6s ease",
            width: `${(earned.length / TROPHIES.length) * 100}%`,
            background: `linear-gradient(90deg, ${DS.accent}, #A89BFF)`,
          }} />
        </div>
      </div>

      {/* Earned */}
      {earned.length > 0 && (
        <div style={card}>
          <div style={label}>Earned — {earned.length}</div>
          <div style={grid}>
            {earned.map(t => {
              const entry = (stats.earnedTrophies || []).find(e => e.id === t.id);
              return (
                <div key={t.id} style={{
                  background: "linear-gradient(145deg, rgba(115,102,240,0.12), rgba(115,102,240,0.04))",
                  border: `1px solid rgba(115,102,240,0.3)`,
                  borderRadius: 12, padding: "16px 12px",
                  display: "flex", flexDirection: "column", alignItems: "center",
                  boxShadow: "0 2px 12px rgba(115,102,240,0.1)",
                }}>
                  <div style={{ fontSize: 34, marginBottom: 8 }}>{t.icon}</div>
                  <div style={{ fontWeight: 700, fontSize: 12, color: DS.text, textAlign: "center" }}>{t.name}</div>
                  <div style={{ fontSize: 11, color: DS.textMuted, textAlign: "center", marginTop: 4, lineHeight: 1.4 }}>{t.desc}</div>
                  {entry && (
                    <div style={{ fontSize: 10, color: DS.textFaint, marginTop: 8 }}>
                      {new Date(entry.earnedAt).toLocaleDateString()}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Locked */}
      {locked.length > 0 && (
        <div style={card}>
          <div style={label}>Locked — {locked.length}</div>
          <div style={grid}>
            {locked.map(t => (
              <div key={t.id} style={{
                background: DS.elevated,
                border: `1px dashed rgba(255,255,255,0.07)`,
                borderRadius: 12, padding: "16px 12px",
                display: "flex", flexDirection: "column", alignItems: "center",
              }}>
                <div style={{ fontSize: 34, marginBottom: 8, filter: "grayscale(1) opacity(0.2)" }}>{t.icon}</div>
                <div style={{ fontWeight: 600, fontSize: 12, color: DS.textFaint, textAlign: "center" }}>{t.name}</div>
                <div style={{ fontSize: 11, color: DS.textFaint, textAlign: "center", marginTop: 4, lineHeight: 1.4, opacity: 0.7 }}>{t.desc}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {earned.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 20px", color: DS.textFaint }}>
          <div style={{ fontSize: 36, marginBottom: 14, opacity: 0.2, color: DS.text }}>♟</div>
          <div style={{ fontSize: 14, fontWeight: 500 }}>Play games to earn trophies</div>
          <div style={{ fontSize: 12, marginTop: 6, color: DS.textFaint }}>Win your first game to get started</div>
        </div>
      )}
    </div>
  );
}

const card = {
  background: DS.surface,
  border: `1px solid ${DS.borderFaint}`,
  borderRadius: DS.radius,
  padding: "18px 20px",
  marginBottom: 16,
};

const label = {
  fontFamily: "'Cinzel', Georgia, serif",
  fontSize: 10, fontWeight: 700, color: DS.textFaint,
  textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 14,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(128px, 1fr))",
  gap: 12,
};
